export default "__VITE_ASSET__ChmO8edq__"